import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setPlacementStep,
  setEditingPosition,
} from "../../redux/objectPlacement";
import { POINT_TYPE } from "./utils";

import PointPlacer from "./PointPlacer";
import AdjustableShape from "./AdjustableShape";
import PlacedObjects from "./PlacedObjects";

const ObjectPlacer = ({ orbitRef }) => {
  const dispatch = useDispatch();

  const placementStep = useSelector(
    (state) => state.objectPlacement.placementStep
  );
  const isPlacementMode = useSelector(
    (state) => state.objectPlacement.isPlacementMode
  );
  const editingPosition = useSelector(
    (state) => state.objectPlacement.editingPosition
  );
  const editingRotation = useSelector(
    (state) => state.objectPlacement.editingRotation
  );
  const editingScale = useSelector(
    (state) => state.objectPlacement.editingScale
  );
  const transformMode = useSelector(
    (state) => state.objectPlacement.transformMode
  );
  const transformAxis = useSelector(
    (state) => state.objectPlacement.transformAxis
  );
  const selectedShape = useSelector(
    (state) => state.objectPlacement.selectedShape
  );
  const shapeParams = useSelector((state) => state.objectPlacement.shapeParams);

  const handlePositionChange = useCallback(
    (newPosition) => dispatch(setEditingPosition(newPosition)),
    [dispatch]
  );

  const handlePointPlace = useCallback(
    (step) => dispatch(setPlacementStep("adjust")),
    [dispatch]
  );

  const handleEditingPositionChange = useCallback(
    (newPosition) => dispatch(setEditingPosition(newPosition)),
    [dispatch]
  );

  return (
    <group>
      <PlacedObjects />
      {isPlacementMode && (
        <>
          {placementStep === "selectXZ" && (
            <PointPlacer
              onPlacePoint={handlePointPlace}
              setEditingPosition={handleEditingPositionChange}
              orbitRef={orbitRef}
              type={POINT_TYPE.POINT_WITH_MARKER}
            />
          )}
          {editingPosition && placementStep !== "selectXZ" && (
            <AdjustableShape
              transformMode={transformMode}
              transformAxis={transformAxis}
              position={editingPosition}
              rotation={editingRotation}
              scale={editingScale}
              onPositionChange={handlePositionChange}
              selectedShape={selectedShape}
              shapeParams={shapeParams}
            />
          )}
        </>
      )}
    </group>
  );
};

export default ObjectPlacer;
